import React from 'react'
import './styles.css'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import Icon from 'components/icons'

function VolumeSlider(props) {
  function toggleVolumeLevel() {
    const volumeLevel = props.value
    if (volumeLevel > 0) {
      props.setValue(0)
    } else {
      props.setValue(100)
    }
  }

  function getVolumeIconName() {
    const volumeLevel = props.value
    if (volumeLevel === 0) {
      return 'vol-off'
    } else if (volumeLevel < 50) {
      return 'vol-mid'
    } else {
      return 'vol-max'
    }
  }

  return (
    <div styleName='volumeControl'>
      <div aria-label={`Speaker ${props.value > 0 ? 'Unmuted' : 'Muted'}`} role='button' styleName='volumeIcon' onClick={toggleVolumeLevel}>
        <Icon name={getVolumeIconName()} fill='#FFF' width={40} />
      </div>
      <div styleName='sliderContainer'>
        <Slider
          value={props.value}
          onChange={props.setValue}
          ariaLabelForHandle='Volume Slider'
          ariaValueTextFormatterForHandle={val => `${val} percent`}
        />
      </div>
    </div>
  )
}

export default VolumeSlider
